import { render, staticRenderFns } from "./foodScenic.vue?vue&type=template&id=05288dce&scoped=true&"
import script from "./foodScenic.vue?vue&type=script&lang=js&"
export * from "./foodScenic.vue?vue&type=script&lang=js&"
import style0 from "./foodScenic.vue?vue&type=style&index=0&id=05288dce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05288dce",
  null
  
)

export default component.exports